export type ChatPrompts = {
  buttonText: string;
  chatText: string;
};

export const defaultChatPrompts: ChatPrompts[] = [
  {
    buttonText: "Activate my phone",
    chatText: "Hey, I'd like help activating my phone.",
  },
  {
    buttonText: "Back up phone",
    chatText: "Hey, I'd like help backing up my phone.",
  },
  {
    buttonText: "Set up phone",
    chatText: "Hey, I'd like help setting up my phone.",
  },
  {
    buttonText: "Transfer apps",
    chatText: "Hey, I'd like help transferring my apps to my new device.",
  },
  {
    buttonText: "Help with something else",
    chatText: "Hey, I'd like help with something else"
  }
];
